import { useIntParam } from 'hooks';
import { lrwSessionStore } from 'store';

export const useSalesChannelAvailability = () => {
  const sessionId = useIntParam('sessionId');
  const { isFetching, data: salesChannelAvailability } =
    lrwSessionStore.service.lrwSessionApi.useGetSalesChannelAvailabilityQuery({
      lrwSessionId: sessionId,
    });

  return { isFetching, salesChannelAvailability };
};
